import { render, staticRenderFns } from "./file-reader.vue?vue&type=template&id=14fc5a78&scoped=true&"
import script from "./file-reader.vue?vue&type=script&lang=js&"
export * from "./file-reader.vue?vue&type=script&lang=js&"
import style0 from "./file-reader.vue?vue&type=style&index=0&id=14fc5a78&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc5a78",
  null
  
)

export default component.exports